(function () {
  const bar = document.getElementById("StickyATC");
  const btn = document.getElementById("StickyATCBtn");
  const btnText = document.getElementById("StickyATCBtnText");
  const variantEl = document.getElementById("StickyATCVariant");
  const priceEl = document.getElementById("StickyATCPrice");
  if (!bar || !btn) return;

  const mainBtn =
    document.querySelector('button[name="add"]') ||
    document.querySelector(".product-form__submit");

  if (!mainBtn) return;

  // Show the bar once the real add-to-cart button has scrolled out of view,
  // hide it again once it's back on screen.
  const io = new IntersectionObserver(
    (entries) => {
      const isMainVisible = entries[0].isIntersecting;
      bar.classList.toggle("is-visible", !isMainVisible);
      bar.setAttribute("aria-hidden", isMainVisible ? "true" : "false");
    },
    { threshold: 0.1 }
  );
  io.observe(mainBtn);

  // Keep price / variant / availability in sync with the real product form
  // using Dawn's own variant-change event (assets/product-info.js publishes
  // this on every option change) instead of duplicating any fetch or price
  // formatting logic. The price text is copied from the HTML Dawn already
  // fetched and formatted server-side (event.data.html), the same source
  // assets/product-info.js itself uses to update the main price element.
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event.data.variant;
      const sectionId = event.data.sectionId;
      const html = event.data.html;

      if (!variant) {
        btn.disabled = true;
        if (btnText && window.variantStrings) btnText.textContent = window.variantStrings.unavailable;
        return;
      }

      if (priceEl && html && sectionId) {
        const sourcePrice = html.getElementById(`price-${sectionId}`);
        if (sourcePrice) {
          const clone = sourcePrice.cloneNode(true);
          // Drop screen-reader-only labels ("Regular price" etc.) so the
          // compact bar only shows the price figure(s) themselves.
          clone.querySelectorAll(".visually-hidden").forEach((node) => node.remove());
          const text = clone.textContent.replace(/\s+/g, " ").trim();
          if (text) priceEl.textContent = text;
        }
      }

      if (variantEl) {
        const isDefault = !variant.title || variant.title === "Default Title";
        variantEl.hidden = isDefault;
        if (!isDefault) variantEl.textContent = variant.title;
      }

      btn.disabled = !variant.available;
      if (btnText && window.variantStrings) {
        btnText.textContent = variant.available
          ? window.variantStrings.addToCart
          : window.variantStrings.soldOut;
      }
    });
  }

  // Reuse the existing product form instead of creating a second one:
  // clicking the sticky button just triggers the real submit button, so
  // Shopify's existing AJAX add-to-cart / cart drawer logic runs unchanged.
  // assets/product-form.js already guards its own submit button against
  // double submission via aria-disabled="true" while a request is in
  // flight — mirror that same check here rather than adding a separate
  // timer-based lock that could drift out of sync with it.
  btn.addEventListener("click", () => {
    if (btn.disabled) return;
    if (mainBtn.getAttribute("aria-disabled") === "true") return;
    mainBtn.click();
  });
})();
